import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    flexGrow: 1,
    paddingRight: 16,
  },
  paper: {
    height: 'auto',
    display: 'grid',
  },
  marginText: {
    fontSize: 12, marginTop: 4, marginLeft: theme.spacing(1),
  },
  marginDefault: {
    margin: theme.spacing(1),
  },
  marginTextDate: {
    fontSize: 12,
    marginTop: 8,
    marginLeft: 8,
  },
  marginDate: {
    marginTop: 4,
    marginLeft: 8,
  },
  margin: {
    margin: theme.spacing(1),
    float: 'right',
  },
  checkbox: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .Mui-checked': {
      color: '#78141B',
    },
  },
  loadingSelect: {
    marginTop: -13,
    marginLeft: theme.spacing(1),
    width: '100%',
    height: 82,
    marginBottom: -5,
  },
}));
